import React, { PropTypes } from 'react';
import validate from 'validate.js';
import { FormControl, FormHelperText } from 'material-ui/Form';
import Input, { InputLabel, InputAdornment } from 'material-ui/Input';

const FileField = ({
    field_name,
    type,
    className,
    onChange,
    label,
    errors,
  }) => {

  let fieldValue = null;

  return(
    <div className={`${className}`}>
      <FormControl style={{ width: '100%', marginBottom: '15px', marginTop: '20px' }}>
        <input
          error={(errors && errors.length)}
          id={field_name}
          name={field_name}
          type='file'
          onChange={
            e => onChange({
              target: {
                value: e.target.files[0],
                name: field_name
              }
            })
          }
          />
          <FormHelperText id="weight-helper-text" error={(errors && errors.length)}>
            {label}{errors && errors.length && `: `} {(errors || [])[0]}
          </FormHelperText>
        </FormControl>
    </div>
  )
}

FileField.propTypes = {
  field_name: PropTypes.string,
  value: PropTypes.string,
  className: PropTypes.string,
  onChange: PropTypes.func,
  label: PropTypes.string ([
    React.PropTypes.node,
    null
  ]),
  errors: PropTypes.oneOfType([
    PropTypes.array,
    null
  ]),
  autoComplete: PropTypes.string
}

export default FileField;



/** WEBPACK FOOTER **
 ** ./src/components/InputField/FileField.jsx
 **/